import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { resolveTenantUrl, tenantOverrideOptions } from 'src/app/Common/ApiConfigurationService/resolve-tenant-url.util';
import {
  UserRoleDTO, 
  UserRoleCreateRequestDTO,
  UserRoleDeleteRequestDTO,
  UserRoleList,
  UserRoleReadBySoftwareIdRequestDTO,
  UserRoleReadByUserIdRequestDTO, 
  UserRoleUpdateRequestDTO,
} from './userRole.interface';

import { Observable } from 'rxjs';
import {
  UserRoles_create,
  UserRoles_delete,
  UserRoles_readAll,
  UserRoles_readBySoftwareId,
  UserRoles_readByUserId,
  UserRoles_update
} from 'src/app/GlobalVariables';

@Injectable({
  providedIn: 'root'
})
export class UserRoleService {
  constructor() { }

  http = inject(HttpClient);

  UserRole_create(data: UserRoleCreateRequestDTO): Observable<UserRoleDTO> {
    return this.http.post<UserRoleDTO>(UserRoles_create, data);
  }

  UserRole_update(data: UserRoleUpdateRequestDTO): Observable<UserRoleDTO> {
    return this.http.post<UserRoleDTO>(UserRoles_update, data);
  }

  // baseUrlOverride (optional): the viewed tenant's own AM gateway origin,
  // e.g. CompanyDetailComponent.apiConfigOverride.AM (company-users tab).
  // Omitted for every other caller - behaves exactly as before.
  UserRole_readByUserId(data: UserRoleReadByUserIdRequestDTO, baseUrlOverride?: string, companyId?: string | number, branchId?: string | number): Observable<UserRoleList> {
    return this.http.post<UserRoleList>(resolveTenantUrl(UserRoles_readByUserId, baseUrlOverride), data, tenantOverrideOptions(baseUrlOverride, companyId ?? 0, branchId ?? 0));
  }

  UserRole_readBySoftwareId(data: UserRoleReadBySoftwareIdRequestDTO): Observable<UserRoleList> {
    return this.http.post<UserRoleList>(UserRoles_readBySoftwareId, data);
  }

  UserRole_readAll(): Observable<UserRoleList> {
    return this.http.get<UserRoleList>(UserRoles_readAll);
  }

  UserRole_delete(data: UserRoleDeleteRequestDTO): Observable<void> {
    return this.http.post<void>(UserRoles_delete, data);
  }
}
